import { render, staticRenderFns } from "./most-popular.vue?vue&type=template&id=5e610a6f&scoped=true&"
import script from "./most-popular.vue?vue&type=script&lang=js&"
export * from "./most-popular.vue?vue&type=script&lang=js&"
import style0 from "./most-popular.vue?vue&type=style&index=0&id=5e610a6f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e610a6f",
  null
  
)

export default component.exports